import * as yup from 'yup';

export const validationSchema = yup.object({
    status: yup
        .boolean()
        .required('Required'),
    integrationId: yup
        .string()
        .required('Required'),
    taskId: yup
        .string()
        .required('Required'),
    taskName: yup
        .string()
        .required('Required'),
    description: yup.
        string().
        required("Requied"),
})

export const initialValues = {
    integrationId: "",
    taskId: "",
    taskName: "",
    description: "",
    status: true,
}